module.exports = __webpack_public_path__ + "img/Logo-Vertebra-final.c81a24e4.png";